<template>
	<div>
		<v-flex xs7 ml-5 mt-4>

			<v-layout wrap v-if="showPurchase">
				<span class="grey--text text--darken-2 caption font-weight-bold uppercase mb-1">Compras</span>

				<v-flex xs12 mb-4>
					<v-select
						background-color="white"
						box
						multiple
						chips
						deletable-chips
						clearable
						class="body-1"
						hide-details
						item-text="name"
						item-value="id"
						label="Documentos de Compra"
						:items="documentTypesPurchases"
						v-model="codePurchase"
						@change="emitChange('codePurchase', $event)"
					></v-select>
				</v-flex>
			</v-layout>
			<v-layout wrap v-if="showSales">
				<span class="grey--text text--darken-2 caption font-weight-bold uppercase mb-1">Ventas</span>

				<v-flex xs12 mb-4>
					<v-select
						background-color="white"
						box
						multiple
						chips
						deletable-chips
						clearable
						class="body-1"
						hide-details
						item-text="name"
						item-value="id"
						label="Documentos de Venta"
						:items="documentTypesSales"
						v-model="codeSales"
						@change="emitChange('codeSales', $event)"
					></v-select>
				</v-flex>
			</v-layout>
		</v-flex>
	</div>
</template>
<script>

export default {
	name: 'configuration-documents',
	props: {
		data: {
			type: Object,
			default: () => ({})
		},
        showPurchase: {
            type: Boolean,
            default: true
        },
        showSales: {
            type: Boolean,
            default: true
        }
	},
	data() {
		return {
            flagType: true,
			codePurchase: [],
			codeSales: [],
			documentTypesSales: [
				{ id: 'FAC', name: 'Factura' },
				{ id: 'BOL', name: 'Boleta' },
				{ id: 'NTV', name: 'Nota de Venta' },
				{ id: 'COT', name: 'Cotización' },
				{ id: 'PED', name: 'Pedido' },
				{ id: 'NDC', name: 'Nota de Crédito' },
				{ id: 'NDD', name: 'Nota de Débito' },
				{ id: 'GRM', name: 'Guía de Remisión' }
			],
			documentTypesPurchases: [
				{ id: 'ORC', name: 'Orden de Compra' },
				{ id: 'FAC', name: 'Factura' },
				{ id: 'BOL', name: 'Boleta' },
				{ id: 'NDC', name: 'Nota de Crédito' },
				{ id: 'GRM', name: 'Guía de Remisión' }
			],
		};
	},
	created() {
		if (
            this.data &&
            this.data.items &&
            this.data.items.data &&
            this.data.items.data.settings &&
            this.data.items.data.settings.msTypeDocumentInit
        ) {
            const settings = this.data.items.data.settings.msTypeDocumentInit;
            this.flagType = settings.flagType !== undefined ? settings.flagType : true;
			this.codePurchase = settings.codePurchase || [];
			this.codeSales = settings.codeSales || [];
		}
	},
	methods: {
		emitChange(key, value) {
			this.$emit('update-settings-documents', { key, value });
		}
	},
	watch: {
		data: {
			handler(newVal) {
				if (
					newVal &&
					newVal.items &&
					newVal.items.data &&
					newVal.items.data.settings &&
					newVal.items.data.settings.msTypeDocumentInit
				) {
					const settings = newVal.items.data.settings.msTypeDocumentInit;
                    this.flagType = settings.flagType !== undefined ? settings.flagType : true;
					const newPurchases = settings.codePurchase || [];
					const newSales = settings.codeSales || [];

					if (JSON.stringify(this.codePurchase) !== JSON.stringify(newPurchases)) {
                        this.codePurchase = newPurchases;
                    }
                    if (JSON.stringify(this.codeSales) !== JSON.stringify(newSales)) {
                        this.codeSales = newSales;
                    }
				}
			},
			deep: true
		}
	}
};
</script>

<style scoped>
span {
	font-size: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration-general/configuration-documents.vue